import styled, { css } from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { Row, media } from '@simplywallst/ui-core';

export const TabLink = styled(RouterLink)<{ selected: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ theme }) => theme.x6spacePx}px;
  padding: ${({ theme }) =>
    `${theme.x2spacePx / 4}px ${theme.x5spacePx / 3}px ${
      theme.x1spacePx / 2
    }px ${theme.x5spacePx / 3}px`};
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  transition: color 0.15s;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.white};
  }
  &:focus-visible {
    background: ${({ theme }) => theme.color.blackRGBA(0.2)};
  }
  &:active {
    transition-duration: 0s;
    color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  }

  ${({ selected, theme }) =>
    selected &&
    css`
      color: ${theme.color.white};
      box-shadow: 0px -${theme.x1spacePx / 3}px 0px 0px inset ${theme.color.brand01};
    `};

  /* Avoid blue tap color on Chrome on Android */
  -webkit-tap-highlight-color: transparent;
`;

export const DesktopSubNav = styled(Row)`
  margin-top: -${({ theme }) => theme.x1spacePx}px;
  padding-right: ${({ theme }) =>
    theme.x5spacePx / 3}px; /* Balanced padding with TabLink */
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  position: sticky;
  top: ${({ theme }) => theme.desktopTopbarHeight}px;
  z-index: 99;
  background: ${({ theme }) => theme.color.charcoal};
`;

export const PageTitle = styled.h1`
  ${({ theme }) => theme.typography.megaStrong}
  margin: ${({ theme }) => `${theme.x4spacePx}px 0`};
  ${media.lgUp`
    text-align: center;
  `};
  ${media.mdDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    margin-bottom: 0;
  `};
`;

export const CTA = styled.p`
  ${({ theme }) => theme.typography.xSmall}
  margin: 0 auto;
  svg {
    display: inline-block;
    margin-bottom: -${({ theme }) => theme.x1spacePx}px;
    margin-left: ${({ theme }) => theme.x1spacePx / 2}px;
    > * {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    }
  }
  ${media.lgUp`
    text-align: right;
  `};
  a:hover,
  a:focus {
    color: ${({ theme }) => theme.color.brand01};
  }
`;
